import React from 'react'
import { Alert } from 'react-bootstrap'
import { openTransactionInExplorer } from '../../../utils/walletUtils'
import { SuccessIconSvg, ClockIconSvg, MailIconSvg } from '../../../assets/svg'

const SuccessStep = ({
  isShielding,
  actionText,
  amount,
  selectedToken,
  actualTxHash,
  shieldTxHash,
  unshieldTxHash
}) => {
  const txHash = actualTxHash || shieldTxHash || unshieldTxHash || 'Pending...'

  return (
    <>
      {/* Success Message */}
      <div className="text-center mb-4 success-heading">
        <div className="mb-3 d-flex justify-content-center">
          <SuccessIconSvg width={80} height={80} />
        </div>
        <h4 className="fw-bold mb-2">🎉 Transaction Submitted!</h4>
        <p className="">
          Your tokens are being {isShielding ? 'shielded' : 'unshielded'}
        </p>
      </div>

      {/* Processing Time Alert */}
      {/* <Alert variant="info" className="mb-3">
        <div className="d-flex align-items-start gap-2">
          <ClockIconSvg width={20} height={20} />
          <div>
            <strong>Processing Time:</strong>
            <br />
            <span className="small">
              The {actionText.toLowerCase()} to {isShielding ? 'private' : 'public'}{' '}
              wallet can take <strong>5-15 minutes</strong> to complete.
            </span>
          </div>
        </div>
      </Alert> */}

      {/* Email Confirmation Alert */}
      {/* <Alert variant="primary" className="mb-3">
        <div className="d-flex align-items-start gap-2">
          <MailIconSvg width={20} height={20} />
          <div>
            <strong>Email Confirmation:</strong>
            <br />
            <span className="small">
              A confirmation email has been sent to your registered email address with
              transaction details.
            </span>
          </div>
        </div>
      </Alert> */}

      {/* Shielding Info Notice */}
      <Alert variant="primary" className="mb-3">
        <div>
          <strong>
            {isShielding ? 'Confirmation of Your Shielding of Funds' : 'Confirmation of Your Unshielding of Funds'}
          </strong>
          <p className="small mt-2 mb-2">
            We’re pleased to inform you that your {isShielding ? 'shielding' : 'unshielding'} of funds is currently being processed.
            You will receive confirmations via email and your Kaxaa inbox at two key stages:
          </p>
          <ul className="small mb-2" style={{ listStyle: 'disc', paddingLeft: '20px' }}>
            {isShielding ?
              <li>When your Shielding of funds is successfully completed</li>
              :
              <li>When your unshielding request is successfully completed</li>
            }
            <li>
              When your funds become spendable in your Kaxaa {isShielding ? 'private' : 'public'} eWallet
            </li>
          </ul>
          <p className="small mb-0">
            Please note that the entire process—including transaction completion, Proof of Innocence (POI) generation, and making the funds spendable—may take up to <strong>2 hours</strong>.
          </p>
        </div>
      </Alert>

      {/* Transaction Receipt */}
      <div className="card">
        <div className="card-body">
          <h6 className="fw-bold mb-3">Transaction Receipt</h6>
          <div className="d-flex justify-content-between py-3">
            <span className="">Amount:</span>
            <span className="fw-bold">
              {amount} {selectedToken?.symbol}
            </span>
          </div>
          <div className="d-flex justify-content-between py-3">
            <span className="">Status:</span>
            <span className="badge bg-warning text-dark">Processing...</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="">Transaction ID:</span>
            <small
              className="font-monospace text-primary"
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => {
                if (txHash && typeof txHash === 'string' && txHash !== 'Pending...') {
                  openTransactionInExplorer(txHash, selectedToken?.network || 'polygon')
                }
              }}
              title="Click to view on blockchain explorer"
            >
              {(typeof txHash === 'string' ? txHash : 'Pending...').slice(0, 20)}...
            </small>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuccessStep
